import { useContext } from 'react';
import { useStore as useZustandStore } from 'zustand';

import { NofomoLoyaltyStoreContext } from './context';
import { NofomoLoyaltyStore } from './zustand';

export const useLoyaltyStore = <T>(
  selector: (store: NofomoLoyaltyStore) => T,
): T => {
  const nofomoStoreContext = useContext(NofomoLoyaltyStoreContext);

  if (nofomoStoreContext === null) {
    throw new Error(`useLoyaltyStore must be used within NofomoStoreProvider`);
  }

  return useZustandStore(nofomoStoreContext, selector);
};

export const useLoyaltyStoreActions = () =>
  useLoyaltyStore((state) => state.actions);
